<template>
    <v-layout wrap class="file-viewer">
        <div class="file-item" v-for="(file, index) in files" :key="index" px-2 mb-2>
            <v-btn color="warning" class="file-remove" dark @click.prevent="removeFile(index)" :disabled="isDisabled">
                <span class="mdi mdi-close mdi-bold"></span>
            </v-btn>
            <div class="file-content" @click.prevent="openFile(index)">
                <v-img v-if="fileTypeChecker(file.type).mimeType === 'Image'" :src="file.url"></v-img>
                <video v-else-if="fileTypeChecker(file.type).mimeType === 'Video'" controls>
                    <source :src="file.url" type="video/mp4" />
                    <source :src="file.url" type="video/ogg" />
                    Your browser does not support the video tag.
                </video>
                <audio v-else-if="fileTypeChecker(file.type).mimeType === 'Audio'" controls>
                    <source :src="file.url" type="audio/ogg" />
                    <source :src="file.url" type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
                <v-img v-else :src="fileTypeChecker(file.type).iconUrl"></v-img>
                <label class="file-cat" v-if="file.categoryName">{{ file.categoryName }}</label>
                <div class="viewer-overlay"></div>
            </div>
        </div>
    </v-layout>
</template>

<script>
    import UploadService from '@/services/Upload';
    export default {
        name: 'files-viewer',
        props: {
            files: { type: Array, required: true, default: () => [] },
            isDisabled: { type: Boolean, required: false, default: false }
        },
        data: () => ({}),
        methods: {
            fileTypeChecker(fileType) {
                if (fileType !== 'exe') {
                    return UploadService.fileMimeTypeChecker(fileType);
                }
            },
            removeFile(fileIndex) {
                this.$emit('removeFileEmitter', fileIndex);
            },
            openFile(fileIndex) {
                window.open(this.files[fileIndex].url, '_blank');
            }
        }
    };
</script>

<style scoped>
    .file-viewer {
        padding: 15px 7.5px 7.5px;
        border: 1px solid #808080;
        background-color: #ebe9e9;
        border-radius: 5px;
    }

    .file-item {
        position: relative;
        min-height: 130px;
        min-width: 130px;
        max-width: 150px;
        border: 2px solid #fff;
        border-radius: 5px;
        margin: 0 7.5px 7.5px;
    }

    .file-content {
        position: relative;
        height: 100%;
        width: 100%;
        cursor: pointer;
        padding: 10px;
    }

        .file-content:hover .viewer-overlay {
            position: absolute;
            z-index: 0;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.15);
        }

    .file-remove {
        position: absolute;
        top: -15px;
        right: -20px;
        height: 25px;
        width: 25px;
        min-width: unset;
        border-radius: 100%;
        padding-left: 0;
        padding-right: 0;
        z-index: 2;
    }

    .file-item video,
    .file-item audio {
        width: 100%;
    }

    .file-cat {
        width: 100%;
        text-align: center;
        padding-top: 5px;
        display: inline-block;
        font-size: 16px;
        color: #4991c3;
    }
</style>